import { Card, Col, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"

function DeclinadoLegalWarning({t, children=null}){


    return (
        <Row>
            <Col xs="12" md={{span: 6, offset: 3}}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <div className="text-center">
                            <p>Usted ha declinado el <strong>CONSENTIMIENTO INFORMADO PARA EL SERVICIO DE TELESALUD </strong>
                            por lo que no puede acceder a dicha cita. Si desea agendar nueva cita por favor realizar nuevamente su 
                            proceso de agendamiento. </p>
                        </div>
                        {children}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(DeclinadoLegalWarning)